import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();
$(function() {

	const groupsSlider = {

		init: function() {
			this.sliderInit();
		},

		sliderInit: function() {
			const responsiveConfig = [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 4
					}
				},
				{
					breakpoint: 575,
					settings: {
						slidesToShow: 3
					}
				}
			];

			$('.js-groups-slider').each(function() {
				const $slider = $(this);
				const $wrapper = $slider.closest('.groups-slider');
				const $progressBar = $wrapper.find('.js-groups-slider-progress');
				const $prevArrow = $wrapper.find('.js-groups-slider-prev');
				const $nextArrow = $wrapper.find('.js-groups-slider-next');
				const $controls = $wrapper.find('.js-groups-slider-controls');
				const itemCount = $slider.children('.groups-slider__item').length;

				// ≤10 items: CSS grid (same look as slider columns), no Slick.
				// 11+: real 2-row slider — config unchanged.
				if (itemCount <= 10) {
					$wrapper.addClass('groups-slider--static');
					$controls.addClass('disabled');
					return;
				}

				const config = {
					autoplay: false,
					infinite: false,
					arrows: true,
					rows: 2,
					slidesToShow: 5,
					slidesToScroll: 1,
					lazyLoad: 'anticipated',
					// See cards-slider: this swallows swipes made mid-transition.
					waitForAnimate: false,
					responsive: responsiveConfig,
					prevArrow: $prevArrow,
					nextArrow: $nextArrow
				};

				$slider.on('init', function(event, slick) {
					if (slick.slideCount <= slick.options.slidesToShow) {
						$controls.addClass('disabled');
					}
				});

				sliders.initializeSlider($slider, config);

				$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
					if (!$progressBar.length) return;

					const total = slick.slideCount;
					const visible = slick.options.slidesToShow;
					const maxIndex = total - visible;

					if (maxIndex <= 0) {
						$progressBar.css('transform', 'scaleX(1)');
						return;
					}

					const calc = Math.min(nextSlide / maxIndex, 1);
					$progressBar.css('transform', `scaleX(${calc})`);
				});
			});
		},
	};

	groupsSlider.init();

});
